<label [for]="name()" [class]="'custom-checkbox body ' + (variant() || '')" [attr.aria-disabled]="disabled">
  <input
    tabindex="0"
    [ngModelOptions]="{ standalone: true }"
    (ngModelChange)="writeValue($event)"
    [ngModel]="value"
    [disabled]="disabled"
    type="checkbox"
    [id]="name()"
    [attr.aria-checked]="value"
    [attr.aria-label]="ariaLabel"
  />
  <span class="checkbox-indicator" aria-hidden="true"></span> <ng-content></ng-content>
</label>
